<template>
  <el-dialog :title="$t('plugin.activityParticipants.title')" :visible="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="realName" :label="$t('plugin.activityParticipants.realName')" align="center"></el-table-column>
      <el-table-column prop="userName" :label="$t('plugin.activityParticipants.accountName')" align="center"></el-table-column>
      <el-table-column prop="createdAt" :label="$t('plugin.activityParticipants.enrollTime')" align="center" min-width="100"></el-table-column>
      <el-table-column prop="condition" :label="$t('plugin.activityParticipants.completedOrders')" align="center"></el-table-column>
      <el-table-column :label="$t('plugin.activityParticipants.completeStatus')" align="center">
        <template slot-scope="scope">{{ completeStatusLabel(scope.row.state) }}</template>
      </el-table-column>
      <el-table-column prop="reward" :label="$t('plugin.activityParticipants.rewardIssue')" align="center"></el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" :current-page="params.page" @current-change="handleCurrentChange"></el-pagination>
  </el-dialog>
</template>

<script>
import { getJoinList } from '@/api/plugins.js';
export default {
  name: 'labelSave',
  data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      params: {
        activityId: '',
        page: 1
      },
      total: 0
    };
  },
  methods: {
    completeStatusLabel(state) {
      const map = {
        1: this.$t('plugin.activityParticipants.completed'),
        2: this.$t('plugin.activityParticipants.notCompleted')
      };
      return map[state] || '--';
    },
    init(id) {
      this.dialogFormVisible = true;
      if (id) {
        this.params.activityId = id;
        this.getNumList();
      }
    },
    getNumList() {
      getJoinList(this.params).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data;
        }
      });
    },
    close() {
      this.dialogFormVisible = false;
      this.$emit('callbackclose');
    },
    handleCurrentChange(msg) {
      this.params.page = msg;
      this.getNumList();
    }
  }
};
</script>
